import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'

import SortToolbarItem from './item.jsx'

/* Styles */
import './index.css'

/* Single Playlist List Item */
export default class SortToolbar extends Component {

    onSelect(name, reverse) {
      if (this.props.onSelect) this.props.onSelect(name, reverse)
    }

    getClassName() {
        const {
            className
        } = this.props
        let classNameArr = className ?className.split(' '):[]
        classNameArr.push('sort-toolbar', 'widget')
        return  classNameArr.join(' ')
    }


    renderItems() {
        const {
          items,
          onChange
        } = this.props
        return _.map(items, (item, index) => {
            return (
                <SortToolbarItem
                  key={ index }
                  index={ index }
                  label={ item.label }
                  name={ item.name }
                  selected={ item.selected }
                  reverse={ item.reverse }
                  title={ item.title }
                  onSelect={ this.onSelect.bind(this) }
                />
            )
        })
    }

    render() {
        return (
            <ul className={ this.getClassName() }>
                { this.renderItems() }
            </ul>
        )
    }
}

SortToolbar.propTypes = {
    items: PropTypes.array,
    onSelect: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/app/widget/sort-toolbar/index.jsx